import { map, atom } from "nanostores"
import { Platform } from "react-native"
import { persistentMap, persistentAtom } from "@nanostores/persistent"

export const createWebPersistentMap = <TObject extends object>(
  name: string,
  initialValue: TObject
) => {
  if (Platform.OS !== "web") {
    return map<TObject>(initialValue)
  }

  return persistentMap<TObject>(name, initialValue, {
    encode(value) {
      return JSON.stringify(value)
    },
    decode(value) {
      try {
        return JSON.parse(value)
      } catch (e) {
        return value
      }
    },
  })
}

export const createWebPersistentAtom = <TValue>(
  name: string,
  initialValue: TValue
) => {
  if (Platform.OS !== "web") {
    return atom<TValue>(initialValue)
  }

  return persistentAtom<TValue>(name, initialValue, {
    encode(value) {
      return JSON.stringify(value)
    },
    decode(value) {
      try {
        return JSON.parse(value)
      } catch (e) {
        return value
      }
    },
  })
}
